import { Injectable, Injector } from "@angular/core";
import { ApiHttpService } from "../apihttp.service";
import { CPUModuleService } from "./CPUModule.service";
import { IOModuleService } from "./IOModule.service";
import { ModuleService } from "./ModuleService";
import { StorageService } from "../storage.service";
import { LockdownService } from "../lockdown.service";
import { BehaviorSubject } from "rxjs";

const INTERVAL = 10; // seconds

export interface BillAcceptorStatus {
  Connected: boolean,
  IsAcceptingBills: boolean,
  Count: number,
  IsEscrow: boolean,
  IsCassettePresent: boolean,
  IsStackerFull: boolean,
  IsBillJammed: boolean,
  IsBusy: boolean,
  IsDeviceFailed: boolean
}

interface CashMeter {
  [key: string]: number;
  BILL_ACCEPTOR_CURRENT_1: number;
  BILL_ACCEPTOR_CURRENT_2: number;
  BILL_ACCEPTOR_CURRENT_3: number;
  BILL_ACCEPTOR_CURRENT_5: number;
  BILL_ACCEPTOR_CURRENT_10: number;
  BILL_ACCEPTOR_CURRENT_20: number;
  BILL_ACCEPTOR_CURRENT_50: number;
  BILL_ACCEPTOR_CURRENT_100: number;
  BILL_ACCEPTOR_CURRENT_COUNT: number;
  BILL_ACCEPTOR_CURRENT_VALUE: number;
  LIFETIME_BILLS_IN_1: number;
  LIFETIME_BILLS_IN_2: number;
  LIFETIME_BILLS_IN_3: number;
  LIFETIME_BILLS_IN_5: number;
  LIFETIME_BILLS_IN_10: number;
  LIFETIME_BILLS_IN_20: number;
  LIFETIME_BILLS_IN_50: number;
  LIFETIME_BILLS_IN_100: number;
  SVC_BILL_ACCEPTOR_IN_1: number;
  SVC_BILL_ACCEPTOR_IN_2: number;
  SVC_BILL_ACCEPTOR_IN_3: number;
  SVC_BILL_ACCEPTOR_IN_5: number;
  SVC_BILL_ACCEPTOR_IN_10: number;
  SVC_BILL_ACCEPTOR_IN_20: number;
  SVC_BILL_ACCEPTOR_IN_50: number;
  SVC_BILL_ACCEPTOR_IN_100: number;
}

interface Denominations {
  [key: string]: number;
  USD_1: number;
  USD_2: number;
  USD_5: number;
  USD_10: number;
  USD_20: number;
  USD_50: number;
  USD_100: number;
  BSD_1: number;
  BSD_2: number;
  BSD_3: number;
  BSD_5: number;
  BSD_10: number;
  BSD_20: number;
  BSD_50: number;
  BSD_100: number;
}

interface BillAcceptedPayload {
  Denomination: 1 | 2 | 3 | 5 | 10 | 20 | 50 | 100;
  Currency: "USD" | "BSD";
}

interface BillAcceptedEvent {
  Payload: BillAcceptedPayload;
}

const TxDenominations = {
  "USD_1": 0,
  "USD_2": 0,
  "USD_5": 0,
  "USD_10": 0,
  "USD_20": 0,
  "USD_50": 0,
  "USD_100": 0,
  "BSD_1": 0,
  "BSD_2": 0,
  "BSD_3": 0,
  "BSD_5": 0,
  "BSD_10": 0,
  "BSD_20": 0,
  "BSD_50": 0,
  "BSD_100": 0,
};

@Injectable({
  providedIn: 'root'
})
export class BillAcceptorService extends ModuleService {
  public denominations = [1, 2, 3, 5, 10, 20, 50, 100]
  public cash_meter: CashMeter = {
    BILL_ACCEPTOR_CURRENT_1: 0,
    BILL_ACCEPTOR_CURRENT_2: 0,
    BILL_ACCEPTOR_CURRENT_3: 0,
    BILL_ACCEPTOR_CURRENT_5: 0,
    BILL_ACCEPTOR_CURRENT_10: 0,
    BILL_ACCEPTOR_CURRENT_20: 0,
    BILL_ACCEPTOR_CURRENT_50: 0,
    BILL_ACCEPTOR_CURRENT_100: 0,
    BILL_ACCEPTOR_CURRENT_COUNT: 0,
    BILL_ACCEPTOR_CURRENT_VALUE: 0,
    LIFETIME_BILLS_IN_1: 0,
    LIFETIME_BILLS_IN_2: 0,
    LIFETIME_BILLS_IN_3: 0,
    LIFETIME_BILLS_IN_5: 0,
    LIFETIME_BILLS_IN_10: 0,
    LIFETIME_BILLS_IN_20: 0,
    LIFETIME_BILLS_IN_50: 0,
    LIFETIME_BILLS_IN_100: 0,
    SVC_BILL_ACCEPTOR_IN_1: 0,
    SVC_BILL_ACCEPTOR_IN_2: 0,
    SVC_BILL_ACCEPTOR_IN_3: 0,
    SVC_BILL_ACCEPTOR_IN_5: 0,
    SVC_BILL_ACCEPTOR_IN_10: 0,
    SVC_BILL_ACCEPTOR_IN_20: 0,
    SVC_BILL_ACCEPTOR_IN_50: 0,
    SVC_BILL_ACCEPTOR_IN_100: 0,
  };
  public tx_denominations: Denominations = TxDenominations;
  public status: BillAcceptorStatus = {
    "Connected": false,
    "IsAcceptingBills": false,
    "Count": 0,
    "IsEscrow": false,
    "IsCassettePresent": false,
    "IsStackerFull": false,
    "IsBillJammed": false,
    "IsBusy": false,
    "IsDeviceFailed": false
  };
  userPresent: any;
  hasAcceptedBills$ = new BehaviorSubject(false)
  endSessionHandler: any;
  endSessionCalls: any[] = [];

  //BillAcceptor
  constructor(public injector: Injector, private io_module: IOModuleService, public http: ApiHttpService, public cpu: CPUModuleService, public storage: StorageService, public lockdownService: LockdownService) {
    super("Bill_Acceptor", injector);
    this.logger.log('Bill_Acceptor constructor')

    this.connection$.subscribe(async (connected) => {
      if (connected) {
        this.billAcceptor_DisableAcceptance()
        this.status = await this.getStatus()
      }
    })
    // this.on('onBillAcceptorConnectedError_Event', (event: any) => {
    //   this.signalR.log('AppLog_Error', { message: "failed to connect", metadata: { event } })
    // })
    this.on('OnBillAcceptorFull_Event', async () => {
      this.cpu.getComputerData().then((cpuInfo) => {
        this.getCashMeters().then((meters) => {
          this.http.notifyAdmin([cpuInfo.KioskName, this.DeviceManagerInterface, 'BIN_FULL'].join(':'),
            JSON.stringify({
              LEVEL: 'PRIO_MEDIUM',
              cpuInfo,
              meters
            }))
        })
      })
    })
    this.on('OnBillAcceptorJam_Event', async () => {
      this.cpu.getComputerData().then((cpuInfo) => {
        this.getCashMeters().then((meters) => {
          this.http.notifyAdmin([cpuInfo.KioskName, this.DeviceManagerInterface, 'BIN_JAM'].join(':'),
            JSON.stringify({
              LEVEL: 'PRIO_MEDIUM',
              cpuInfo,
              meters
            }))
        })
      })
    })
    this.on('OnBillAcceptorFailure_Event', async () => {
      this.cpu.getComputerData().then((cpuInfo) => {
        this.getCashMeters().then((meters) => {
          this.http.notifyAdmin([cpuInfo.KioskName, this.DeviceManagerInterface, 'BIN_FAILURE'].join(':'),
            JSON.stringify({
              LEVEL: 'PRIO_HIGH',
              cpuInfo,
              meters
            }))
        })
      })
    })
  }

  public isAvailable(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      resolve(!this.config.KIOSK_ENABLED || (this.status.Connected && !this.status.IsDeviceFailed && !this.status.IsStackerFull))
    })
  }


  public getStatus(): Promise<BillAcceptorStatus> {
    return new Promise((resolve, reject) => {
      if (!this.status.Connected) {
        this.callMethod('BillAcceptor_GetDeviceStatus')
          .then((response: BillAcceptorStatus) => {
            resolve(response)
          }).catch(() => {
            resolve(this.status)
          })
      } else {
        resolve(this.status)
      }
    })
  }

  public updateInsertedCashMeter(denom: number, quantity: number) {
    return this.callMethod('BillAcceptor_SetInsertedCashMeter', denom, quantity);
  }

  public updateCashMeters(isAccept: boolean) {
    if (!isAccept) {
      this.denominations.map((denom) => {
        this.updateInsertedCashMeter(denom, this.cash_meter['BILL_ACCEPTOR_CURRENT_' + denom])
      })
    }
  }

  async tryToAcceptBill(): Promise<any> {
    if (this.config.KIOSK_ENABLED) {
      return this.BillAcceptor_GetDeviceStatus().then(async (status) => {
        let canAccept = await this.canAccept(status)
        if (!canAccept.status) {
          return Promise.reject({ ...canAccept })
        }
        if (status.Connected) {
          if (!status.IsAcceptingBills) {
            return this.billAcceptor_EnableAcceptance()
          }
          return Promise.resolve({ message: "Already accepting" })
        }
        return Promise.reject({ message: "Not connected" })
      }).catch((error) => {
        return Promise.reject({ message: "Failed to get device status" })
      })
    }
    return Promise.resolve({ message: "Not in Kiosk Mode" })
  }

  public trackDenominations(event: BillAcceptedEvent) {
    let bill: BillAcceptedPayload = event.Payload
    let key = [bill.Currency, bill.Denomination].join('_');
    this.tx_denominations[key]++;
    let timestamp = +new Date
    this.hasAcceptedBills$.next(true)
    this.http.mute().kioskLog({
      type: 'event',
      name: 'onBillAcceptorAccepted_Event',
      event,
      timestamp
    })
    this.lockdownService.setUserPresent()
  }

  public startSession() {
    this.signalR.log('AppLog_Info', { message: 'startSession called' })
    this.tx_denominations = { ...TxDenominations };
    // TODO: SHOULD BE COMPUTED FROM METERS
    this.on('onBillAcceptorAccepted_Event', this.trackDenominations.bind(this), false)
    // this.userPresent = setInterval(() => {
    //   this.lockdownService.setUserPresent()
    // }, 1000);
    // this.signalR.log('AppLog_Info', { message: 'SetUserPresent interval called' })
    this.lockdownService.setUserPresent()
    this.signalR.log('AppLog_Info', { message: 'SetUserPresent called' })
    return this;
  }

  public async endSession(): Promise<void> {
    this.signalR.log('AppLog_Info', { message: 'endSession called' })
    if (!this.endSessionHandler) {
      return new Promise((resolve, reject) => {
        this.getStatus().then(async (status) => {
          if (!status.IsBusy) {
            this.off('onBillAcceptorAccepted_Event')//, this.trackDenominations.bind(this))
            let meters = await this.getCashMeters()
            let user = this.storage.get('user')
            this.http.mute().post(this.config.API_SAVE_METER_IN, { session: user.SessionID, terminal_id: user.TerminalId, meters: JSON.stringify(meters) })
            // clearInterval(this.userPresent)
            // this.signalR.log('AppLog_Info', { message: 'SetUserPresent interval cleared' })
            resolve()
            this.endSessionCalls.forEach((r) => r())
          }
        })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.endSessionCalls.push(resolve)
      })
    }
  }

  public getTxDenominations(): Promise<Denominations> {
    return new Promise((resolve, reject) => {
      resolve(this.tx_denominations);
    })
  }

  public billAcceptor_EnableAcceptance() {
    return this.setOpenCloseAcceptor("billAcceptor_EnableAcceptance", true);
  }

  public billAcceptor_Connect() {
    return this.callMethod("billAcceptor_Connect");
  }

  public billAcceptor_IsConnected(): Promise<any> {
    return this.callMethod("billAcceptor_IsConnected");
  }

  public billAcceptor_IsStackerFull() {
    return this.callMethod("billAcceptor_IsStackerFull");
  }

  public billAcceptor_IsJammed() {
    return this.callMethod("billAcceptor_IsJammed");
  }

  public BillAcceptor_IsCassettePresent() {
    return this.callMethod("BillAcceptor_IsCassettePresent");
  }

  public BillAcceptor_IsBusy() {
    return this.callMethod("BillAcceptor_IsBusy");
  }

  public BillAcceptor_GetDeviceStatus(): Promise<BillAcceptorStatus> {
    return this.callMethod("BillAcceptor_GetDeviceStatus");
  }

  public billAcceptor_Stack() {
    return this.callMethod("billAcceptor_Stack");
  }

  public billAcceptor_Return() {
    return this.callMethod("billAcceptor_Return");
  }

  public billAcceptor_GetCount() {
    return this.callMethod("billAcceptor_GetCount");
  }

  public billAcceptor_ClearCount() {
    return this.callMethod("billAcceptor_ClearCount");
  }

  /**
   * @deprecated
   * @returns
   */
  public billAcceptor_GetCashMeters(): Promise<CashMeter> {
    return this.callMethod("billAcceptor_GetCashMeters");
  }

  public clearCashMeters() {
    return this.callMethod('BillAcceptor_ResetCurrentCashMeters')
  }

  public getCashMeters(): Promise<CashMeter> {
    return this.callMethod("billAcceptor_GetCashMeters");
  }

  public billAcceptor_DisableAcceptance(): Promise<any> {
    return this.setOpenCloseAcceptor("billAcceptor_EnableAcceptance", false);
  }

  public billAcceptor_Disconnect() {
    return this.callMethod("billAcceptor_Disconnect");
  }

  public module(toggle: boolean) {
    this.io_module.turnOutputDevice(toggle, 3).then((r) => {
      this.logger.log('turned ' + (toggle ? 'on' : 'off') + ' module 3')
    }).catch((e) => {
      this.logger.log('Failed to turn Module 3 ' + (toggle ? 'on' : 'off'))
      this.logger.log(e)
    })
  }

  public canAccept(status?: BillAcceptorStatus) {
    return (status ? Promise.resolve(status) : this.getStatus()).then((status) => {
      let canAccept = !(status.IsDeviceFailed || status.IsBillJammed || status.IsStackerFull);
      return {
        status: canAccept,
        message: !canAccept ? "Error Status: " + ([
          { IsDeviceFailed: "Device Failed" },
          { IsBillJammed: "Bill Jammed" },
          { IsStackerFull: "Stacker Full" },
        ].filter(i => (<any>status)[Object.keys(i)[0]]).join(", ")) : ""
      }
    })
  }

  private async setOpenCloseAcceptor(method: string, isAccept: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      this.callMethod(method, isAccept).then((response: any) => {
        // this.logger.log(method)
        this.module(isAccept)
        // this.updateCashMeters(isAccept)
        resolve(response)
      }).catch((err: any) => {
        this.logger.log("Error :" + err)
      });
    });
  }

}
